<template>
    <div class="page-checkout-step-shipping-cdek-delivery-point">
        <div class="shipping-cdek-delivery-point__item _active">
            <div class="shipping-cdek-delivery-point__item-title">
                {{deliveryPointTitle}} СДЭК
            </div>
            <div>{{deliveryPoint.code}}</div>
            <br/>
            <div class="shipping-cdek-delivery-point__item-address-container">
                <div>{{deliveryAddress}}</div>
                <div class="shipping-cdek-delivery-point__item-map" v-if="deliveryMapLink">
                    <a :href="deliveryMapLink" target="_blank" class="shipping-cdek-delivery-point__item-map-link">
                        На карте
                    </a>
                </div>
            </div>
            <br/>
            <div>{{deliveryPoint.work_time}}</div>
            <div v-if="deliveryTimeFormatted">Срок доставки: {{deliveryTimeFormatted}}</div>
            <br/>
            <div>✓</div>
        </div>
        <div class="page-checkout-step-shipping-cdek-delivery-point__change" v-on:click="changeDeliveryPoint">
            Изменить пункт самовывоза
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-checkout-step-shipping-cdek-delivery-point',
    computed: {
        checkoutData() {
            return this.$store.state.checkout.data;
        },
        deliveryPoint() {
            return this.$store.state.checkout.data?.cdekDeliveryPoint;
        },
        deliveryPointTitle() {
            return this.deliveryPoint.type === 'PVZ'
                ? 'Пункт самовывоза'
                : (this.deliveryPoint.type === 'POSTAMAT' ? 'Постамат' : '');
        },
        deliveryAddress() {
            let result = '';
            const location = this.deliveryPoint.location;
            if (location.city) {
                result += location.city + ', ';
            } else if (location.region) {
                result += location.region + ', ';
            }
            return result + location.address;
        },
        deliveryMapLink() {
            return this.deliveryPoint.location?.address_full
                ? `https://yandex.ru/maps/?text=${this.deliveryPoint.location.address_full}`
                : null;
        },
        deliveryTimeFormatted() {
            return this.$store.getters['checkout/cdekPointDeliveryTimeFormatted'];
        },
    },
    methods: {
        changeDeliveryPoint() {
            this.$store.commit('sideblocks/push', {
                name: 'delivery-point',
                props: {},
            });
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';
.page-checkout-step-shipping-cdek-delivery-point__change {
    margin-top: 20px;
    .mixin-link-decoration();
}

.shipping-cdek-delivery-point {
    &__item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        min-height: 100%;
        padding: 16px 29px 16px 20px;
        border: 1px solid @color-gray-darkest;

        background-color: @color-gray-lightest;

        cursor: pointer;

        transition: background-color @duration-fast @easing-default;
        &:hover,
        &._active {
            background-color: @color-accent-yellow;
        }
        &._active & {
            &__trigger {
                display: none;
            }
            &__check {
                display: block;
            }
        }
        &-title {
            text-transform: uppercase;
        }
        &-address-container {
            display: flex;
            justify-content: space-between;
            gap: 36px;
            width: 100%;
        }
        &-map {
            flex-shrink: 0;
        }
        &-map-link {
            .mixin-link-decoration();
        }
    }
}

</style>
